export const TOKEN_KEY = 'menu-cost:token'
export const REMEMBER_KEY = 'menu-cost:remember'

export function getApiUrl() {
  const c = window.MENU_COST_CONFIG
  if (c && c.API_URL) return String(c.API_URL).replace(/\/$/, '')
  return ''
}

export function token() {
  return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY)
}

export function setToken(t, remember) {
  sessionStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(TOKEN_KEY)
  if (!t) return
  if (remember ?? localStorage.getItem(REMEMBER_KEY) === '1') {
    localStorage.setItem(TOKEN_KEY, t)
  } else {
    sessionStorage.setItem(TOKEN_KEY, t)
  }
}

export function logout() {
  setToken(null)
  location.hash = '#/login'
}

export async function api(path, opts = {}) {
  const base = getApiUrl()
  if (!base) throw new Error('API URL not configured')
  const headers = { ...(opts.headers || {}) }
  if (opts.body && typeof opts.body === 'string' && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }
  const t = token()
  const isAuthRequest = path === '/auth/login' || path === '/auth/login/'
  if (t && !isAuthRequest) headers.Authorization = 'Bearer ' + t

  const res = await fetch(base + path, { ...opts, headers })
  if (res.status === 401) {
    logout()
    throw new Error('Session expired')
  }
  const text = await res.text()
  let data
  try {
    data = text ? JSON.parse(text) : {}
  } catch {
    data = { raw: text }
  }
  if (!res.ok) {
    const err = data.error || res.statusText || 'Request failed'
    throw new Error(err)
  }
  return data
}